module.exports = __webpack_public_path__ + "static/img/supersound2.8ec958d5.png";